/**
 * RedirectFromRoot — Slice-4 Default-Route-Migration.
 *
 * Bis Slice-3 war `/` = LibraryPage (Default-Route). Slice-4 macht
 * `/dashboard` zur Default-Route, Library zieht auf `/library` um.
 *
 * Diese Komponente lebt OUTSIDE des Layout-Wrappers (siehe App.tsx
 * Outer-Switch) — kein Sidebar/Topbar-Flash auf `/`. Renders `null`,
 * der useEffect dispatcht zum Ziel.
 *
 * Filter-Heuristik (Pattern aus tasks/spec.md Item 9):
 * - `/?type=image&q=foo` → `/library?type=image&q=foo` (Bookmark-preserve)
 * - `/?utm_source=ad` → `/dashboard` (kein Filter-Param)
 * - `/?type=image&utm_source=ad` → `/library?type=image` (NUR
 *   LIBRARY_FILTER_PARAMS durchgereicht, unbekannte discarded)
 *
 * `replace: true` damit `/` nicht im History-Stack landet (Browser-Back
 * skipped korrekt zu vorheriger Page).
 */
import { useEffect, useRef } from 'react';
import { useLocation, useSearchParams } from 'wouter';
import { LIBRARY_FILTER_PARAMS } from '../lib/redirect-rules';

export function RedirectFromRoot() {
  const [, setLocation] = useLocation();
  const [searchParams] = useSearchParams();
  const redirectedRef = useRef(false);

  useEffect(() => {
    if (redirectedRef.current) return; // idempotency-guard
    redirectedRef.current = true;

    const filtered = new URLSearchParams();
    let hasFilterParam = false;
    for (const key of LIBRARY_FILTER_PARAMS) {
      const v = searchParams.get(key);
      if (v !== null) {
        filtered.set(key, v);
        hasFilterParam = true;
      }
    }
    const target = hasFilterParam ? `/library?${filtered.toString()}` : '/dashboard';
    setLocation(target, { replace: true });
  }, [searchParams, setLocation]);

  return null;
}
